import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useNavigate, Link } from "react-router-dom";
import MentorCarousel from "@/components/MentorCarousel";

const MentorSearch = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <div className="w-full">
      {/* Search Input - Hidden on mobile since it's in the header */}
      <div className="text-center mb-10">
        
        <form onSubmit={handleSearch} className="hidden md:block relative max-w-2xl mx-auto mb-8">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-muted-foreground w-5 h-5 z-10" />
          
          {/* Desktop input - full placeholder */}
          <Input
            type="text"
            placeholder="Search by name, expertise, credits, or specialty..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-12 pr-16 py-3 text-lg bg-card/50 border-border/50 rounded-full focus:bg-card/80 transition-all duration-200"
          />
          
          <Button 
            type="submit"
            size="sm"
            className="absolute right-2 top-1/2 transform -translate-y-1/2 rounded-full px-4 z-10"
          >
            Search
          </Button>
        </form>
      </div>

      {/* Swipe indicator */}
      <div className="text-xl text-muted-foreground flex items-center justify-center gap-2 mb-1">
        <span>Swipe</span>
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
        </svg>
      </div>

      {/* Default Mentor Carousel - with triplication intact */}
      <MentorCarousel showTitle={false} />
    </div>
  );
};

export default MentorSearch;